import { JobProgressNotification } from "src/app/shared/modals/job-follow-up/models/job-progress-notification";
import { JobStatus } from "../enums/job-status.enum";

export class JobParams {
    jobId: string;
    jobName:string;
    filters: { [key: string]: any };
    cycleId: number;
    group: number;
    processId: number;
    type: string;
    downloaded: boolean;
    progress?: JobProgressNotification;
    status?: JobStatus;
    pageComponentName?: string;
    
    constructor(params: Partial<JobParams>) {
        Object.assign(this, params);
    }
}